import { createAction, handleActions } from 'redux-actions';

const SET_DEVICE = 'deviceEnv/SET_DEVICE';

export const currentDevice = createAction(SET_DEVICE);

const initialState = {
  env:''
};

const deviceEnv = handleActions(
  {
    [SET_DEVICE]: (state, { payload: env }) => env,
  },
  initialState
);

export default deviceEnv;
